<script setup>
import SectionHeading from '@common/SectionHeading'
import {
  computed,
  defineAsyncComponent,
  onMounted,
  onUpdated,
  reactive,
  ref,
  shallowRef,
} from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { useStore } from '@admin_js/store'
import Confirmation from '@common/Confirmation'

const store = useStore()

const isModalVisible = ref(false)

const isNew = computed(() => {
  return !!Inertia.page.props.routes.store
})

onMounted(() => {
  store.setResource(Inertia.page.props.resource)
})

let form = reactive({ ...Inertia.page.props.entity })

const getField = function (component) {
  return defineAsyncComponent(() => import(`@common/Fields/${component}.vue`))
}

const submitForm = () => {
  if (isNew.value) {
    Inertia.post(route(Inertia.page.props.routes.store), form)
  } else {
    Inertia.post(
      route(Inertia.page.props.routes.update, {
        [Inertia.page.props.resource]: form.id,
      }),
      form
    )
  }
}

const deleteItem = (response) => {
  isModalVisible.value = false
  if (response) {
    Inertia.delete(
      route(Inertia.page.props.routes.delete, {
        [Inertia.page.props.resource]: form.id,
      })
    )
  }
}
</script>

<template>
  <SectionHeading :label="Inertia.page.props.title">
    <template v-slot:actions>
      <slot name="actions">
        <div class="mt-3 sm:mt-0 sm:ml-4"></div>
      </slot>
    </template>
  </SectionHeading>
  <ul
    v-if="Object.entries(Inertia.page.props.errors).length > 0"
    class="space-y-1.5 border border-red-200 bg-red-50 py-2 px-4 text-sm text-red-700"
  >
    <li v-for="error in Inertia.page.props.errors">{{ error }}</li>
  </ul>
  <form @submit.prevent :class="Inertia.page.props.classes?.join(' ')">
    <component
      v-bind:is="getField(field.component)"
      v-for="field in Inertia.page.props.fields"
      :field="field"
      :entity="Inertia.page.props.entity"
      v-model="form[field.name]"
      :key="field.name"
    >
      >
    </component>
    <div>
      <button
        type="submit"
        @click="submitForm()"
        class="mt-3 mr-3 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
      >
        Bewaar
      </button>
      <div
        v-if="!isNew"
        @click="isModalVisible = true"
        class="mt-3 inline-flex cursor-pointer items-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
      >
        Verwijder
      </div>
    </div>
  </form>
  <slot name="afterForm"></slot>
  <Confirmation
    v-if="isModalVisible"
    @onDelete="deleteItem"
    message="Bent u zeker dat u dit item wenst te verwijderen?"
  ></Confirmation>
</template>
